import React from 'react';
import Alert from 'react-s-alert';
import Raven from 'raven-js';

import Withdraws from 'api/resources/withdraws';
import { processErrorByAlert } from 'utils/getErrors';

import PopupButton from 'components/PopupButton';
import Popup from 'components/Popup';
import ButtonLoader from 'components/Loader/ButtonLoader';

import Label from 'styled/Label';
import Input from 'styled/Input';
import PrimaryButton from 'styled/Buttons/PrimaryButton';

import FormWrapper from './FormWrapper';
import PopupWrapper from './PopupWrapper';
import InputWrapper from './InputWrapper';

const TODAY = new Date();
const TODAY_ISO = new Date().toISOString().substr(0, 10);
const WEEK_AGO = TODAY.setDate(TODAY.getDate() - 7);
const WEEK_AGO_ISO = new Date(WEEK_AGO).toISOString().substr(0, 10);

class FormReportPopup extends React.PureComponent {
  state = {
    isFormReportOpen: false,
    startDate: WEEK_AGO_ISO,
    endDate: TODAY_ISO,
    loading: false,
  };

  handleFormReportOpen = () => {
    this.setState({ isFormReportOpen: true });
  }

  handleFormReportClose = () => {
    this.setState({ isFormReportOpen: false });
  }

  handleDateChange = ({ target }) => {
    this.setState({ [target.id]: target.value });
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    if (this.state.startDate > this.state.endDate) {
      Alert.error('Ошибка валидации. Дата начала не может быть больше конечной даты');
      return;
    }

    this.setState({ loading: true });

    try {
      await Withdraws.report({
        filter: {
          start_date: Number(new Date(this.state.startDate)) / 1000,
          end_date: Number(new Date(`${this.state.endDate}T23:59:59`)) / 1000,
        },
      });

      Alert.success('Вы получите отчет за указанный временной период на почту, после того как отчет будет сформирован системой');
      this.setState({ loading: false, isFormReportOpen: false });
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });

      Raven.captureException(err, { extra: this.props });
    }
  }

  render() {
    return (
      <div style={{ position: 'relative' }}>
        <PopupButton
          onClick={this.handleFormReportOpen}
          label="Сформировать отчет"
          isPopupOpen={this.state.isFormReportOpen}
        />

        <PopupWrapper>
          <Popup
            isVisible={this.state.isFormReportOpen}
            onClickOnBackdrop={this.handleFormReportClose}
            isControlled
          >
            <FormWrapper>
              <form onSubmit={this.handleSubmit}>
                <Label htmlFor="startDate">Указать даты</Label>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <InputWrapper>
                    <Input
                      id="startDate"
                      type="date"
                      value={this.state.startDate}
                      onChange={this.handleDateChange}
                      required
                      max={TODAY_ISO}
                      style={this.state.startDate ? { color: '#fff' } : undefined}
                    />
                  </InputWrapper>

                  <span style={{ alignSelf: 'center' }}> — </span>

                  <InputWrapper>
                    <Input
                      id="endDate"
                      type="date"
                      value={this.state.endDate}
                      onChange={this.handleDateChange}
                      required
                      max={TODAY_ISO}
                      style={this.state.endDate ? { color: '#fff' } : undefined}
                    />
                  </InputWrapper>
                </div>

                <PrimaryButton
                  type="submit"
                  disabled={this.state.loading}
                  style={{ marginTop: '16px' }}
                >
                  {this.state.loading
                    ? <ButtonLoader />
                    : 'Скачать CSV'
                  }
                </PrimaryButton>
              </form>
            </FormWrapper>
          </Popup>
        </PopupWrapper>
      </div>
    );
  }
}

export default FormReportPopup;
